import React from 'react'
import { Radio } from "antd"

type UseRadioButtonProps = {options: Array<any>, defaultValue?: String}
export const useRadioButton = ({options = [], defaultValue = ''}: UseRadioButtonProps) => {
    const [value, setValue] = React.useState(defaultValue)
    return [
        () => (<Radio.Group
            options={options}
            onChange={e => setValue(e.target.value)}
            value={value}
            optionType="button"
            buttonStyle="solid"
        />),
        value, 
        setValue
    ]
}